// extracted by mini-css-extract-plugin
var _1 = "HoverButton__innerLink--jkuqS OfficeGeneral__centeredRow--GA99n OfficeGeneral__centeredRowBase--jxfGw";
var _2 = "HoverButton__main--x8j3T OfficeGeneral__colorButton--b_MmO CoreGeneral__colorButton--ZcxJ7 CoreGeneral__colorButtonBase--ROvbs CoreGeneral__roboto--UlmjE";
var _3 = "HoverButton__mainHover--Y0cR2";
export { _1 as "innerLink", _2 as "main", _3 as "mainHover" }
